/**
 * @generated SignedSource<<21fe5e6e88f9f6dbbedb220f35712545>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type MeetingContainerTabs_note$data = {
  readonly hasMeetingRecordings: boolean;
  readonly meetingRecordings: ReadonlyArray<{
    readonly isCurrentlyRecording: boolean | null;
  }> | null;
  readonly " $fragmentSpreads": FragmentRefs<"utils_useMeetingRecorderStatus_note">;
  readonly " $fragmentType": "MeetingContainerTabs_note";
};
export type MeetingContainerTabs_note$key = {
  readonly " $data"?: MeetingContainerTabs_note$data;
  readonly " $fragmentSpreads": FragmentRefs<"MeetingContainerTabs_note">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "MeetingContainerTabs_note",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasMeetingRecordings",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "MeetingRecording",
      "kind": "LinkedField",
      "name": "meetingRecordings",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isCurrentlyRecording",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "utils_useMeetingRecorderStatus_note"
    }
  ],
  "type": "Note",
  "abstractKey": null
};

(node as any).hash = "7081a17d94ef95f1f37d3589ff32622c";

export default node;
